import { useState, useEffect } from 'react';

export default function useCollectionsFetch (refs, dependencies = []) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if(!refs) return;

    let cleanedUp = false;
    (async () => {
      const data = (await Promise.all(refs.map(_ => _.get())))
        .reduce((x, y) => [...x, ...y.docs], [])
        .map(_ => ({ id: _.id, ref: _.ref, ..._.data() }))
      if(!cleanedUp) {
        setItems(data);
      }
    })();
    return _ => cleanedUp = true;
  }, dependencies);
  return items;
};
